import React, { useRef, useState } from "react";
import appHelpers from "../../common/helpers/appHelpers";
import { Button } from "../components/Elements";
import Filters from "../components/PaymentErpSync/Filters";
import IntegrationTable from "../components/PaymentErpSync/IntegrationTable";
import PageTitle from "../components/PageTitle";
import { pageTitleTexts } from "../../constants/texts/pageTitleTexts";
import { buttonTexts } from "../../constants/texts/buttonTexts";
import { exportExcelHelper } from "../../common/helpers/exportExcelHelper";
import { useSelector } from "react-redux";
import { usePermissionCheck } from "../../hooks/usePermissionCheck";
import { UserOperationTypes } from "../../common/types/AuthorizationProps";

export default function PaymentSyncErp() {

  usePermissionCheck(UserOperationTypes["Erp Entegrasyonu"], "ERP Fiş Aktarımı izni yok");
  const formFilterRef = useRef();
  const tableSelectedRows = useRef();
  
  const [filtersIsOpen, setFiltersIsOpen] = useState(true);
  const [excelLoading, setExcelLoading] = useState(false);
  const [headCells, setHeadCells] = useState([])
  const platform = appHelpers.getPlatform();
  const isWebPlatform = platform == "web";
  

  const { integrationList }= useSelector((state) => state.Integration);

  const getTitle = () => {
    if (isWebPlatform) {
      return "";
    }
    return appHelpers.getPlatform() === "NETSIS" ? "Netsis" : "Logo";
  }

  const handleHeadCells = (values) => {
    setHeadCells(values);
  }

  const exportToExcelClick = async () => {
    setExcelLoading(true);
    try {
      exportExcelHelper(integrationList, "orderid", tableSelectedRows, headCells, "ERP-Fis-Aktarimi_Listesi");
    } catch (error) {

    } finally {
      setExcelLoading(false);
    }
  };

  return (
    <div className="w-full">
      <PageTitle title={pageTitleTexts.paymentSyncErp} />

      <div className="px-4 pt-2 flex flex-row items-center justify-between space-y-2">
        <div className="flex flex-row items-center">
          <img src={"/icons/tahsilat-mutabakatlari-dark.svg"} className="h-6 w-6 black" />
          <span className="text-lg font-bold leading-7 text-contrast-90 sm:truncate ml-2">
            {getTitle()} ERP Fiş Aktarımı
          </span>
        </div>

        <div className=" flex flex-row justify-end items-center px-2">
          <Button
            size="xs"
            hover="gray"
            color="gray"
            callback={() => setFiltersIsOpen(!filtersIsOpen)}
          >
            <span className="mr-3">{buttonTexts.filterOpen}</span>
            <img src="/icons/filter.svg" alt="filter" />
          </Button>
        </div>
      </div>

      <Filters ref={formFilterRef} isOpen={filtersIsOpen} setFiltersIsOpen={setFiltersIsOpen} />
      {/* <div className='flex flex-row-reverse pr-4 space-x-3 space-x-reverse'>
        <Button
          color="gray"
          hover="gray"
          size="xs"
          callback={() => exportToExcelClick()}
          loading={excelLoading}
          disabled={excelLoading}
        >
          <img src="/icons/download-blue.svg" alt="pushToExcel" />
          <span className='ml-3'>{buttonTexts.exportToExcel}</span>
        </Button>
      </div> */}
      <IntegrationTable formFilterRef={formFilterRef} tableSelectedRows={tableSelectedRows} getHeadCells={handleHeadCells} />
    </div>
  );
}
